import React, { useState } from "react";
import './earnings-invoice.scss'
import { Row, Radio, Col, Card, Tag, Button, Table, Input, Divider, Space, Dropdown, Spin, Modal, Form, Select, DatePicker, Tabs } from "antd";
import addFrame from "../../assets/images/earning-invoice-addFrame.svg";
import calendar from "../../assets/images/earning-invoice-calender.svg";
import leftArrow from "../../assets/images/earning-invoice-left-arrow.svg";
import plus from "../../assets/images/earning-invoice-plus.svg";

import { useNavigate } from "react-router-dom";

const EarningInvoice = () => {
    const [invoiceData, setInvoiceData] = useState([
        {
            "invoiceId": "13401",
            "issuedOn": "18th July 2024",
            "ShipmentDateRange": "03 July - 11 July",
            "totalOrder": 10,
            "totalTrips": 24,
            "totalAmount": "AED 2,000",
            "verificationStatus": "Verification In Progress"
        },
        {
            "invoiceId": "13401",
            "issuedOn": "18th July 2024",
            "ShipmentDateRange": "03 July - 11 July",
            "totalOrder": 10,
            "totalTrips": 24,
            "totalAmount": "AED 2,000",
            "verificationStatus": "Approved"
        },
        {
            "invoiceId": "13401",
            "issuedOn": "18th July 2024",
            "ShipmentDateRange": "03 July - 11 July",
            "totalOrder": 10,
            "totalTrips": 24,
            "totalAmount": "AED 2,000",
            "verificationStatus": "Verification In Progress"
        },
        {
            "invoiceId": "13401",
            "issuedOn": "18th July 2024",
            "ShipmentDateRange": "03 July - 11 July",
            "totalOrder": 10,
            "totalTrips": 24,
            "totalAmount": "AED 2,000",
            "verificationStatus": "Verification In Progress"
        },
    ])
     const navigate = useNavigate();
    const handleAddInvoice = () =>{
       navigate("/earnings/add-new-invoice/USER123")
       
    }

    return (
        <div className="earning-invoice-wrapper">
            {invoiceData.length ?


                //    when previous Invoices are there 

                <div>
                    <Row className='invoice-btn-row'>
                        <div className="invoice-upload"><img src={leftArrow} alt="icon" /> Invoice Upload</div>
                        <div className="add-new-invoice"  onClick={handleAddInvoice}><Button className='add-new-btn'><img src={plus} alt="+" />Add New Invoice</Button></div>
                    </Row>
                    <div className="card-container">
                        {invoiceData?.map((item, index) => {
                            return (
                                <div className="invoice-card-wrapper">
                                    <Row className="invoice-id-row">
                                        <div className="invoice-id-div">
                                            <span className="invoice-id">
                                                Invoice ID: {item?.invoiceId}
                                            </span>
                                            <span className="issued-on">
                                                <img src={calendar} alt="icon" /> Issued On {item?.issuedOn}
                                            </span>
                                        </div>
                                        <div className={`verificationStatus ${item?.verificationStatus === 'Approved' ? 'Approved' : 'verificationStatus'}`}>
                                            {item?.verificationStatus}
                                        </div>
                                    </Row>


                                    <Row className="Range-row">
                                        <Col span={8} className="range-comman-class">
                                            <span className="range-title-comman-class">
                                               Total Earnings
                                            </span>
                                            <span className="range-value-comman-class">
                                            {item?.totalAmount}
                                            </span>
                                        </Col>
                                        <Col span={8} className="range-comman-class">
                                            <span className="range-title-comman-class">
                                                Total Orders
                                            </span>
                                            <span className="range-value-comman-class">
                                                {item?.totalOrder}
                                            </span>
                                        </Col>
                                        <Col span={8} className="range-comman-class">
                                            <span className="range-title-comman-class">
                                                Total Trips
                                            </span>
                                            <span className="range-value-comman-class">
                                                {item?.totalTrips}
                                            </span>
                                        </Col>
                                    </Row>
                                   
                                </div>
                            )
                        })}
                    </div>
                </div> :


                //    when no previous invoice are there we need to add the invoice 

                <div>
                    <Row className='invoice-btn-row'>
                        <div className="invoice-upload"><img src={leftArrow} alt="icon" /> Invoice Upload</div>

                    </Row>
                    <div className="add-invoice-wrapper">
                        <div className="request-your-payment">
                            <div> <img src={addFrame} /></div>
                            <div className="payment-request"> Request Your Payment</div>
                            <div className="payment-desc"> Get payment instantly by uploading the Invoice documents and POD documents.</div>
                            <Button className="add-new-btn" onClick={handleAddInvoice}><img src={plus} alt="+" />Add Invoice</Button>
                        </div>
                    </div>

                </div>}

                     

        </div>
    )
}
export default EarningInvoice;